import React from "react";

export default function SingleUserSearch({
  value,
  onChange,
  onSearch,
  onClear,
  loading,
  user,
}) {
  return (
    <div className="col-span-2 mt-4 p-4 bg-red-50 rounded-lg border border-red-200 min-w-0">
      <label className="block text-sm font-semibold text-gray-700 mb-2">
        Search User by Email or Contact Number *
      </label>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onSearch();
            }
          }}
          placeholder="Enter email or contact number"
          className="flex-1 min-w-0 p-2.5 text-xs md:text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white text-gray-700"
        />
        <button
          type="button"
          onClick={onSearch}
          disabled={loading || !value.trim()}
          className={`px-4 sm:px-6 py-2.5 rounded-lg font-semibold text-sm transition-all shadow-md whitespace-nowrap ${
            loading || !value.trim()
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-red-500 text-white hover:bg-red-600 hover:shadow-lg"
          }`}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>
      {user && (
        <div className="mt-3 p-3 bg-white rounded-lg border border-red-200 shadow-sm min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-800 truncate">
                {user.firstName} {user.lastName}
              </p>
              <p className="text-xs text-gray-600 truncate">
                {user.email} | {user.contactNo || "N/A"}
              </p>
            </div>
            <button
              type="button"
              onClick={onClear}
              className="text-red-600 hover:text-red-700 hover:bg-red-50 px-2 py-1 rounded text-sm font-medium transition-colors self-start sm:self-center flex-shrink-0">
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
